"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getToolbar = void 0;
const components_1 = require("@veeam/components");
const types_1 = require("../types");
const getToolbar = (texts) => {
    return {
        items: [
            components_1.toolbarSearchFilter({
                property: types_1.POLICY_FILTER_KEY.search,
                fieldConfig: {
                    placeholder: texts.placeholder,
                },
            }),
        ],
    };
};
exports.getToolbar = getToolbar;
//# sourceMappingURL=getToolbar.js.map